import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { makeStyles } from '@mui/core/styles';
import { useTheme, styled } from '@mui/material/styles';

import { Box, Stack, Link, Card, CardActions, Button, Divider, Typography, CardContent, Rating } from '@mui/material';
import moment from 'moment';
import { SpaceBar } from '@mui/icons-material';

import AppsService from '../../../services/apps_service'
import { LoadingButton } from '@mui/lab';

const useStyles = styled((theme) => ({
    root: {
        width: '100%',
        maxWidth: '800px',
        margin: '0 auto',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    title: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
    },
    content: {
        fontSize: '1rem',
        marginTop: theme.spacing(1),
    },
    rating: {
        marginTop: theme.spacing(2),
    },
    author: {
        fontSize: '0.8rem',
        color: '#6c757d',
        marginTop: theme.spacing(1),
    },
    date: {
        fontSize: '0.8rem',
        color: '#6c757d',
        marginLeft: theme.spacing(1),
    },
    metadata: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(1),
    },
    country: {
        fontSize: '0.8rem',
        color: '#6c757d',
        marginLeft: theme.spacing(1),
    },
}));

const Review = ({ id, title, content, rating, author, date, country, app_version }) => {
    const classes = useStyles();

    const formattedDate = date; //moment(date).format('DD.MM.YYYY HH:mm');
    const [translation, setTranslated] = useState('')
    const [translating, setTranslating] = useState(false)


    function handleTranslate() {
        setTranslating(true);
        AppsService.translate_review(id)
            .then(response => {
                setTranslated(response.data['data'])
                setTranslating(false);
            })
            .catch(error => {
                setTranslating(false);
            })
    }

    return (
        <Card className={classes.root}>
            <CardContent>
                <Typography className={classes.title} color="textPrimary" gutterBottom>
                    {title}
                </Typography>
                <Rating
                    className={classes.rating}
                    name="rating"
                    value={rating}
                    size="large"
                    readOnly
                />
                <Typography className={classes.content} variant="body2" component="p">
                    {content}
                </Typography>
                <br />
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography className={classes.country} mr={1}>{app_version}</Typography>
                    <Typography className={classes.date}>{formattedDate}</Typography>
                </Box>
                <Typography className={classes.author}>{author}</Typography>
                <Typography className={classes.country}>{country}</Typography>
                <br />
                <LoadingButton loading={translating} variant='outlined' spacing={0} onClick={handleTranslate}>Translate</LoadingButton>
                <Typography className={classes.content} variant="body2" component="p">
                    {translation}
                </Typography>
            </CardContent>
        </Card>
    );
};

Review.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    rating: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    app_version: PropTypes.string.isRequired,
};

export default Review;